<template>
  <div class="page height-full">
    <app-header :title="title()"/>
    <div class="container-fluid" v-if="isLoading">
      <spinner style="margin-top: 25%"></spinner>
    </div>
    <div v-else>
      <b-card v-if="showOnboarding == true" >
        <b-col md='8' offset='2' style="padding-top: 10%;padding-bottom: 10%">
          <h2 class="text-center">Welcome to the Boom Media<br />family! 🎉</h2>
          <h4 class="text-center">Here’s a list of items that need to be completed before we can get started. </h4>
          <b-row class="mt-5">
            <b-col  md="8" offset="2">
              <div v-if="account.signedContract == 1" class="d-flex justify-content-between align-items-center">
                <del>Sign Contract that was sent via email,</del>
              </div>
              <div v-else class="d-flex justify-content-between align-items-center">
                Sign Contract that was sent via email.
              </div>
              <br />
              <div v-if="account.paidSetupFee == 1" class="d-flex justify-content-between align-items-center">
                <del>Process payment for setup fee.</del>
              </div>
              <div v-else class="d-flex justify-content-between align-items-center">
                Process payment for setup fee. <a href="#" @click="checkout">Click here to pay.</a>
              </div>
              <br />
              <div v-if="account.invitedPartnerFacebook == 1"class="d-flex justify-content-between align-items-center">
                <del>Invite Boom Media Partner ID (149968322724384) to your Facebook Ad Account.</del>
              </div>
              <div v-else class="justify-content-between align-items-center">
                <b-row>
                  <b-col md="9">Invite Boom Media Partner ID (149968322724384) to your Facebook Ad Account. View instructions <a href="https://www.facebook.com/business/help/1717412048538897?id=2190812977867143" target="_blank">here</a>.</b-col><b-col md="3"><a href="#" class="float-right" @click="fbComplete">Mark as completed.</a></b-col>
                </b-row>
              </div>
              <br />
              <div v-if="account.uploadedDriveContent == 1" class="d-flex justify-content-between align-items-center">
                <del>Upload content to Google Drive.</del>
              </div>
              <div v-else class="justify-content-between align-items-center">
                Upload content to <a :href="account.googleDriveUrl" target="_blank">this Google Drive.</a><a href="#" class="float-right" @click="gDriveComplete">Mark as completed.</a>
              </div>
              <br />
              <div v-if="account.invitedTeam == 1" class="d-flex justify-content-between align-items-center">
                <del>Invite your team members.</del>
              </div>
              <div v-else class="d-flex justify-content-between align-items-center">
                Invite your team members. <a href="#" @click="inviteTeam">Invite Team.</a>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-card>
      <div class="container-fluid" v-else>
        <b-row>
          <b-col md="12" style="text-align: right;">
            <div v-if="account != null">
              <b-form-select class="mt-3" style="float: left;width: 200px;" v-model="selectedAdAccount" :options="options"></b-form-select>
            </div>
            <date-range-picker
              class="mr-2 mt-3"
              v-model="dateRange"
              opens="left"
              :minDate="new Date(new Date().setFullYear(new Date().getFullYear() - 1))"
              :maxDate="new Date()"
              @update="updateValues"
            ></date-range-picker>
          </b-col>
        </b-row>
        <div class="row my-3" v-if="account != null">
          <div class="col-md-4">
            <div class="counter-box white r-5 p-3">
              <div class="p-3">
                <div v-if="isLead()">
                  <div class="counter-title">Leads</div>
                  <h5 class="sc-counter mt-3">{{data.totalLeads}}</h5>
                </div>
                <div v-else>
                  <div class="counter-title">Revenue</div>
                  <h5 class="sc-counter mt-3">{{'$' + data.totalRevenue}}</h5>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="col-md-4">
            <div class="counter-box white r-5 p-3">
              <div class="p-3">
                <div class="counter-title">Ad Spend</div>
                <h5 class="sc-counter mt-3">{{'$' + data.adSpend}}</h5>
              </div>
            </div>
          </div>
          <br />
          <div class="col-md-4">
            <div class="counter-box white r-5 p-3">
              <div class="p-3">
                <div v-if="isLead()">
                  <div class="counter-title">Cost Per Lead</div>
                  <h5 class="sc-counter mt-3">{{costPerLead}}</h5>
                </div>
                <div v-else>
                  <div class="counter-title">ROAS</div>
                  <h5 class="sc-counter mt-3">{{data.roas}}</h5>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <b-row>
          <div class="col-md-12 mb-3">
            <div class="counter-box white r-5 p-3">
              <div class="p-3">
                <div class="counter-title mb-3">Top Campaigns</div>
                <div>
                  <b-table v-if="campaigns.length > 0" striped hover :items="items()"></b-table>
                  <p v-else>No active ads during this time period.</p>
                </div>
              </div>
            </div>
          </div>
        </b-row>
        <!-- <div class="row">
          <div class="col-md-12">
            <div class="white r-5 p-3">
              <div class="p-3">
                  <h4 class="text-center">Last 30 Days</h4>
                  <h6 class="text-center">Ad Performance</h6>
              </div>
              <simple-chart width="1000" height="600"
                              id="messages-chart"
                              type="line"
                              :labels="messageData.dates"
                              :data="messageData.values"
                              :border-color="'rgba(0, 213, 184, 1)'"
                              border-width="2"
                              fill="false"></simple-chart>
            </div>
          </div>
        </div> -->
        <div class="mt-3 mb-3"><b-btn class="brand-purple" @click="billing">Manage Billing</b-btn></div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { Auth } from 'aws-amplify';
  import axios from 'axios'
  import Constants from '../Constants'
  import Spinner from './common/Spinner'
  import SimpleChart from './SimpleChart'
  import Vue from 'vue'
  import DateRangePicker from 'vue2-daterange-picker'
  //you need to import the CSS manually (in case you want to override it)
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  

  export default {
    name: 'Dashboard',
    components: {
      Spinner,
      SimpleChart,
      DateRangePicker
    },
    data() {
      return {
        data: {
          totalRevenue: '0',
          adSpend: '0',
          roas: '0',
          totalLeads: '0'
        },
        campaigns: [],
        account: null,
        selectedAdAccount: null,
        dateRange: {
          startDate: '',
          endDate: '',
        },
        dateOptions: {
          day: 'numeric', 
          month: 'numeric',
          year: 'numeric'
        },
        options: [],
        chartsLib: null,
        showDialog: false,
        isLoading: false,
        account: null,
        showUpgradePrompt: false,
        isAdmin: false,
        messageData: {
          dates: [],
          values: []
        },
        subscriberData: {
          dates: [],
          values: []
        },
        messagesData: [],
        plan: '',
        messagesOptions: {
          chart: {
            title: "Messages Performance",
            subtitle: 'Last 30 days',
          },
          height: 500,
          maxLines: 7,
          legend: {position: 'none'},
          width: 100
        },
        subscribersData: [],
        subscribersOptions: {
          chart: {
            title: 'Subscribers Performance',
            subtitle: 'Last 30 days',
          },
          height: 500,
          maxLines: 7,
          legend: {position: 'none'}
        },
        dashboard: {
          subscriberCount: 0,
          credits: 0,
          phoneNumbers: []
        },
        showChart: false,
      }
    },
    methods: {
      resetData() {
        this.data = {
          totalRevenue: '0',
          adSpend: '0',
          roas: '0',
          totalLeads: '0'
        }
        this.campaigns = []
      },
      isLead() {
        if (this.account == undefined) { return false }
        if (this.account.engagementType == undefined) { return false }
        return this.account.engagementType == 'lead'
      },
      adAccountChanged(event) {
        console.log(event)
        this.getDashboard()
      },
      items() {
        var items = []
        console.log('=== campaigns ===')
        console.log(this.campaigns)
        if (this.account == undefined) { return items }
        if (this.campaigns === undefined) { return items }
        const c = this.campaigns

        if (this.account.engagementType == 'lead') {
          c.forEach(campaign => {
            var leads = 0
            campaign.actions.forEach(action => {
              if (action.action_type == "lead") {
                leads += Number(action.value)
              }
            })

            var costPerLead = 0
            if (leads > 0) {
              costPerLead = Number(campaign.spend) / leads
            }

            const item = { 
              name: campaign.campaign_name, 
              adSpend: '$' + Number(campaign.spend).toFixed(2), 
              leads: leads,
              costPerLead: '$' + Number(costPerLead).toFixed(2)
            }
            items.push(item)
          })
        } else {
          c.forEach(campaign => {
            var roas = 0
            if (campaign.purchase_roas !== undefined) {
              if (campaign.purchase_roas.length > 0) {
                roas = campaign.purchase_roas[0].value
              }
            }

            var revenue = 0
            if (campaign.spend !== undefined) {
              revenue = Number(roas) * Number(campaign.spend)
            }
            
            const item = { 
              name: campaign.campaign_name, 
              adSpend: '$' + Number(campaign.spend).toFixed(2), 
              revenue: '$' + revenue.toFixed(2),
              ROAS: Number(roas).toFixed(2)
            }
            items.push(item)
          }) 
        }
        
        return items
      },
      formatted(date) {
        // Format YYYY-MM-DD
        const a = new Date(date)
        const month = ("0" + (a.getMonth() + 1)).slice(-2); 
        const day = ("0" + a.getDate()).slice(-2); 
        const year = a.getFullYear()
        return year + '-' + month + '-' + day
      },
      dateFormat (classes, date) {
        if (!classes.disabled) {
          classes.disabled = date.getTime() < new Date()
        }
        return classes
      },
      updateValues(event) {
        this.getDashboard()
      },
      onChartReady(chart, google) {
        this.chartsLib = google
      },
      dismissOnboarding: function() {
        this.showDialog = false
      },
      formatPhoneNumbers(numbers) {
        var str = ""
        console.log(numbers)
        if (numbers.length == 0) { return str }

        var n = numbers.split(",")
        console.log(n)
        for (var i = 0; i < n.length; i++) {
          var phone = n[i]
          str += Constants.FORMAT_PHONE_NUMBER(phone) + "\n"
        }
        return str        
      },
      billing() {
        var url = '/stripe/billing?accountId=' + this.account.sk
        if (this.account.stripeCustomerId !== undefined) {
          url += '&stripeCustomerId=' + this.account.stripeCustomerId
        }
        axios.get(Constants.API_URL + url)
            .then(response => {
              if (response.data.url) {
                window.location.href = response.data.url
              }
            }).catch(err => {
              console.error(err)
            })
      },
      title() {
        if (this.account == null) {
          return "Dashboard"
        } else {
          return this.account.name + " Dashboard"
        }
      },
      getAccount() {
        this.isLoading = true;
        const id = this.$route.params.id
        axios.get(Constants.API_URL + '/accounts/' + id)
          .then(response => {
            console.log(response);
            this.account = response.data.Items[0]
            this.options = []
            this.account.adAccounts.forEach(act => {
              this.options.push({value: act.id, text: act.name + ' (' + act.id + ')'})
            })
            if (this.options.length > 0) {
              this.selectedAdAccount = this.options[0].value
            }
            return this.getDashboard()
          }).catch((err) => {
            console.log(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      getDashboard() {
        console.log('getting dashboard')
        const adAccountId = this.selectedAdAccount
        if (adAccountId === undefined) {
          console.log('ad account undefined.')
          return 
        }

        this.isLoading = true;
        const id = this.$route.params.id
        const path = '/accounts/' + id + 
          '/dashboard?adAccountId=' + adAccountId + 
          '&startDate=' + this.formatted(this.dateRange.startDate) + 
          '&endDate=' + this.formatted(this.dateRange.endDate)
        axios.get(Constants.API_URL + path)
          .then(response => {
            console.log(response);
            this.campaigns = response.data.insights
            var adSpend = 0
            var revenue = 0
            var roas = 0
            var leads = 0

            // Calculate metrics
            this.campaigns.forEach(campaign => {
              console.log(campaign)
              var r = 0
              if (campaign.purchase_roas !== undefined) {
                if (campaign.purchase_roas.length > 0) {
                  r = Number(campaign.purchase_roas[0].value) * Number(campaign.spend)  
                }
              }
              const spend = Number(campaign.spend)
              revenue += r
              adSpend += spend

              campaign.actions.forEach(action => {
                if (action.action_type == "lead") {
                  leads += Number(action.value)
                }
              })
            })

            if (revenue > 0) {
              roas = Number(revenue / adSpend).toFixed(2)
            }

            revenue = Number(revenue).toFixed(2)
            adSpend = Number(adSpend).toFixed(2)
            this.data.totalRevenue = revenue
            this.data.adSpend = adSpend
            this.data.roas = roas
            this.data.totalLeads = leads
          }).catch((err) => {
            this.resetData()
            console.log(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      setChartData() {
        var dates = []
        var values = []
        for (var i = 0; i < 30; i++) {
          var d = new Date();
          d.setDate(d.getDate() - i);
          dates.push(d.toString())
          values.push(Math.floor(Math.random() * 1000))
        }
        this.messageData = {
          dates: dates,
          values: values
        }
        console.log('=== message data ===')
        console.log(this.messageData)
      },
      fbComplete() {
        const id = this.accountId
        const acct = this.account
        this.account = null
        acct.invitedPartnerFacebook = 1
        this.account = acct
        const data = {
          invitedPartnerFacebook: 1
        }
        axios.put(Constants.API_URL + '/accounts/' + id, data)
          .then(response => {
            console.log(response)
          }).catch(err => {
            console.error(err)
          })
      },
      gDriveComplete() {
        const id = this.accountId
        const acct = this.account
        this.account = null
        acct.uploadedDriveContent = 1
        this.account = acct
        const data = {
          uploadedDriveContent: 1
        }
        axios.put(Constants.API_URL + '/accounts/' + id, data)
          .then(response => {
            console.log(response)
          }).catch(err => {
            console.error(err)
          })
      },
      inviteTeam() {
        // PUT Request to mark task as completed. 
        const id = this.accountId
        const data = {
          invitedTeam: 1
        }
        axios.put(Constants.API_URL + '/accounts/' + id, data)
          .then(response => {
            console.log(response)
          }).catch(err => {
            console.error(err)
          })

        // redirect to team management.
        this.$router.push('/accounts/' + id + '/users')
      },
      checkout() {
        // TODO: should get this from the URL param.. 
        axios
          .get(Constants.API_URL + "/stripe/checkouts?accountId=" + this.accountId)
          .then(response => {
            console.log(response);
            return this.redirect(response.data.id)
          }).catch((err) => {
            swal("", err.message, "error").show()
          })
      },
      redirect(sessionId) {
        var stripe = Stripe(Constants.STRIPE_KEY);
        stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (result) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          console.log(result.error.message)
        });
      }
    },
    computed: {
      costPerLead() {
        if (this.data.totalLeads > 0) {
          console.log('=== Ad spend ===')
          console.log(this.data.adSpend)

          console.log('=== totalLeads ===')
          console.log(this.data.totalLeads)
          return '$' + Number(Number(this.data.adSpend) / Number(this.data.totalLeads)).toFixed(2)
        } else {
          return '$0'
        }
      },
      showOnboarding() {
        if (this.isLoading) {
          return false
        }

        if (this.account === null) {
          return false
        }

        if (this.account.signedContract == 1 &&
            this.account.paidSetupFee == 1 &&
            this.account.invitedPartnerFacebook == 1 && 
            this.account.uploadedDriveContent == 1 &&
            this.account.invitedTeam == 1) {
          return false
        } else {
          return true
        }
      },  
      showUpgradeBanner: function() {
        return this.plan !== 'subscribed'
      },
      accountId() {
        return this.$route.params.id
      }
    },
    mounted() {
      const date = new Date()
      const str = date.toLocaleString('en-us', this.dateOptions)
      this.dateRange.startDate = str
      this.dateRange.endDate = str
      this.setChartData()

      Auth.currentAuthenticatedUser()
        .then(user => {
          user.signInUserSession.accessToken.payload['cognito:groups'].forEach(role => {
            if (role == "admin") { 
              this.isAdmin = true 
            }
          })

          if (this.isAdmin == true) {
            window.location.href = "/admin"
          } else {
            this.getAccount()
          }
        }).catch(err => {
          console.error(err)
        })
    }
  }
</script>
<style>
  .alert {
    margin-top: 16px;
  }

  .credits {
    color: dimgray;
  }

  .upgrade {
    position: relative;
    float: right;
  }

  .upgrade a {
    text-decoration: blue;
  }

  .description {
    margin-top: 20px;
  }

  .md-dialog-actions {
    justify-content: center;
    padding: 0;
  }

  .centered {
    text-align: center;
    display: block;
    width: 100%;
  }

  .content {
    margin-left: 100px;
    margin-right: 100px;

  }

  .content-bottom {
    margin-bottom: 50px;
  }

  .btn-gray {
    margin-bottom: 20px;
    background-color: #e3e3e3;
    color: white;
    text-align: center;
  }

  .counter-box {
    height: 100%;
  }

  .float-right {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue